import { getScopeDynamicRangeValue } from '@/components/QueryWidgets/RangeDatePickerV2'

// 用于生成默认的用户设置项,
export const getDefaultConfig = (fields, reset = false) => {
    const result = {}

    const getSort = (reset, item, index) => {
        if (reset) {
            return item.resetDefaultSort || index
        }
        return item.sort || index
    }
    const getShow = (reset, item) => {
        if (reset) {
            return 'resetDefaultShow' in item ? !!item?.resetDefaultShow : true
        }
        return 'defaultShow' in item ? item?.defaultShow : true
    }

    fields.forEach((item, index) => {
        result[item.name] = {
            show: getShow(reset, item),
            sort: getSort(reset, item, index),
            enable: true
        }
    })

    return result
}

/**
 * 用初始的表单数据和用户配置项组合成的渲染数组
 * @param {*} fields 组件传入的表单原始数据
 * @param {*} config 用户配置的表单配置项 null表示用户没有配置过，{}表示不是可配置的筛选区
 * @param {*} whenHideDisplayNone
 * @returns
 */
export const transConfigToRenderArr = (fields, config, whenHideDisplayNone, queryConfigKey) => {
    let _config = config
    if (!queryConfigKey) {
        return fields
    }
    if (!config || !Object.keys(config).length) {
        // 当用户没有配置过的时候,这个时候需要用下面的进行生成渲染的配置项
        // 当没有配置时，生成相应的默认用户配置项
        _config = getDefaultConfig(fields)
    }

    return fields
        ?.map((item, index) => {
            // 当在fields中找不到用户配置的时,会设置成{ show: true, sort: index, enable: true }
            const setting =
                _config && _config[item.name] ? _config[item.name] : { show: true, sort: index, enable: true }
            return {
                ...item,
                setting,
                show: setting?.show
            }
        })
        .filter(item => {
            return whenHideDisplayNone ? true : item?.setting?.show
        })
        .sort((a, b) => (a?.setting?.sort || 0) - (b?.setting?.sort || 0))
}

export const getUnshowFieldNames = config => {
    const target = []
    Object.keys(config).forEach(key => {
        if (!config[key].show) {
            target.push(key)
        }
    })
    return target
}

// 处理一键排序接口的数据
export const formatQuickSortData = (data, fields, config, groupFields) => {
    let upKeys = []
    const keys = Object.keys(data)
        .filter(key => !!config[key])
        .sort((a, b) => data[a].sort - data[b].sort)

    keys.forEach(key => {
        if (upKeys.includes(key)) {
            return
        }
        const _group = groupFields?.find(group => group.some(item => item === key))
        if (_group) {
            upKeys = [...upKeys, ..._group]
        } else {
            upKeys = [...upKeys, key]
        }
    })
    const allKeys = fields
        .sort((prev, next) => {
            return prev.sort - next.sort
        })
        .map(i => i.name)
    upKeys.reverse()
    allKeys.sort((prev, next) => {
        return upKeys.indexOf(next) - upKeys.indexOf(prev)
    })
    const result = {}
    allKeys.forEach((key, index) => {
        result[key] = {
            ...config[key],
            sort: index
        }
    })
    return result
}

// 将快捷查询的值转换为筛选项表单的值
export const transQuickSearchValueToQueryFormValue = quickSearchValue => {
    const queryFormValue = {}
    Object.keys(quickSearchValue).forEach(key => {
        const value = quickSearchValue[key]
        if (value?.dynamicTimeRangeScope) {
            // 动态的时间类型
            queryFormValue[key] = {
                ...value,
                ...getScopeDynamicRangeValue({
                    dynamicTimeRangeScope: value.dynamicTimeRangeScope,
                    startFormat: value.startFormat,
                    endFormat: value.endFormat
                })
            }
        } else {
            queryFormValue[key] = value
        }
    })
    return queryFormValue
}
